import axios from 'axios';
import router from '@/router';

// Development: proxy üzerinden istek at (CORS yok). Production: doğrudan API.
const baseURL = process.env.NODE_ENV === 'development'
  ? '/api'
  : (process.env.VUE_APP_API_BASE || 'https://ptduo.tederga.dev/2/trainer/api/1.0');

const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// --- REQUEST INTERCEPTOR (Token) ---
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- RESPONSE INTERCEPTOR (401 → Login) ---
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Sözleşme / ayar kontrollerinde 401 (CORS veya yetki) kullanıcıyı çıkış yapma
      if (error.config.skipAuthRedirect) {
        return Promise.reject(error);
      }
      localStorage.removeItem('jwt');
      localStorage.removeItem('user');
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

/**
 * API hatalarından anlamlı mesaj üretir.
 * @param {Error} error - axios veya servis hatası
 * @returns {string} Kullanıcıya gösterilebilecek mesaj
 */
export function getApiErrorMessage(error) {
  if (!error) return 'Beklenmeyen bir hata oluştu.';
  if (error.response) {
    const { data, status } = error.response;
    if (data && typeof data.info === 'string') return data.info;
    if (data && typeof data.message === 'string') return data.message;
    if (status === 403) return 'Bu işlem için yetkiniz yok.';
    if (status === 404) return 'Kaynak bulunamadı.';
    if (status >= 500) return 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.';
  }
  if (error.message) {
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) return 'İstek zaman aşımına uğradı.';
    if (error.message.includes('Network')) return 'Ağ bağlantısı kurulamadı.';
  }
  return 'Bir hata oluştu. Lütfen tekrar deneyin.';
}

export default apiClient;
